var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    ref: "containerRef",
    staticClass: "virtual-tree"
  }, [_c('div', {
    staticClass: "virtual-tree-spacer",
    style: {
      height: _vm.totalHeight + 'px'
    }
  }, [_c('div', {
    staticClass: "virtual-tree-content",
    style: {
      transform: 'translateY(' + _vm.offsetY + 'px)'
    }
  }, _vm._l(_vm.visibleNodes, function (node) {
    return _c('div', {
      key: node.id,
      staticClass: "tree-node",
      class: {
        'node-active': node.checked,
        'node-expanded': node.expand
      },
      style: {
        paddingLeft: node.depth * 20 + 'px'
      },
      on: {
        "click": function ($event) {
          return _vm.handleNodeClick(node);
        }
      }
    }, [_vm.hasChildren(node) ? _c('div', {
      staticClass: "tree-node-icon",
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.toggleNode(node);
        }
      }
    }, [!node.expand ? _c('Icon', {
      attrs: {
        "type": "ios-arrow-forward"
      }
    }) : _c('Icon', {
      attrs: {
        "type": "ios-arrow-down"
      }
    })], 1) : _c('div', {
      staticClass: "tree-node-icon-placeholder"
    }), _c('div', {
      staticClass: "tree-node-label"
    }, [_c('span', {
      staticClass: "tree-node-text",
      attrs: {
        "title": node.name
      }
    }, [_vm._v(_vm._s(node.name))])]), _vm.isAdmin ? _c('div', {
      staticClass: "tree-node-more",
      on: {
        "click": function ($event) {
          $event.stopPropagation();
        }
      }
    }, [_c('Dropdown', {
      attrs: {
        "transfer": "",
        "placement": "bottom-start"
      }
    }, [_c('Icon', {
      attrs: {
        "type": "md-more",
        "size": 18
      }
    }), _c('DropdownMenu', {
      staticClass: "tree-node-more-dropdown",
      attrs: {
        "slot": "list"
      },
      slot: "list"
    }, [_c('DropdownItem', {
      nativeOn: {
        "click": function ($event) {
          return _vm.$emit('onAdd', node);
        }
      }
    }, [_vm._v($t("enc3e35", "添加子部门"))]), node.level > 0 ? _c('DropdownItem', {
      nativeOn: {
        "click": function ($event) {
          return _vm.$emit('onEdit', node);
        }
      }
    }, [_vm._v($t("e5fv2", "修改"))]) : _vm._e(), node.level > 0 ? _c('DropdownItem', {
      nativeOn: {
        "click": function ($event) {
          return _vm.$emit('onDelete', node);
        }
      }
    }, [_vm._v($t("eslg2", "删除"))]) : _vm._e()], 1)], 1)], 1) : _vm._e()]);
  }), 0)])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };